/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import {client} from '../Client';
import { Form } from 'semantic-ui-react'
import {convertNullToEmptyString, arrayToCombo, arrayToComboAdd} from '../Helpers'
import PropTypes from 'prop-types';
class TestiDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo: this.props.tipo,
            itemList: [],
            dropdownLoading: false,
        };
        this.lastNewValue = undefined;
        this.onItemAddition = this.onItemAddition.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onLoading = this.onLoading.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    onLoading(value){
        this.setState({ dropdownLoading: value });
        if (this.props.onLoading !== undefined){
            this.props.onLoading(value)
        }
    }

    loadDropdown(){
        this.onLoading(true);
        client.loadTestiPerTipoList(this.state.tipo).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.onLoading(false);
                    this.setState({
                        error: null,
                        itemList: arrayToCombo(data, "valore", "valore", "valore")
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.onLoading(false);
                    this.setState({
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.onLoading(false);
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    onItemAddition = (e, { value }) => {
        if (value.length > this.props.maxlength){
            value = value.substring(0, this.props.maxlength);
        }

        this.lastNewValue = value;

        this.onLoading(true);
        client.saveTestiPerTipo(
            this.state.tipo, value
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    data = convertNullToEmptyString(data);
                    //let fields = this.state.fields;
                    //fields.forma = data.valore;
                    this.onLoading(false);
                    this.setState({
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        itemList: arrayToComboAdd(this.state.itemList, data, 'valore', 'valore', 'valore')
                    }, () => {
                        this.props.onChange(undefined, {name: this.props.name, value: data.valore})
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else{
                this.onLoading(false);
                this.setState({
                    inError: true,
                    fieldErrors: {'forma': 'errore salvataggio testo'},
                    fieldErrorsText: ["errore caricamento testo"],
                    errorTitle: "Errore imprevisto",
                });
            }
        }).catch((error) => {
            this.onLoading(false);
            this.setState({
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onChange(ev, {name, value}){
        if (value !== undefined && value.length <= this.props.maxlength)
        {
            this.props.onChange(ev, {name, value})
        }
        else {
            ev.preventDefault();
        }
    }

    onSearchChange(ev, value){
        if (value !== undefined && value.length > this.props.maxlength)
        {
            ev.preventDefault();
        }
    }

    componentWillMount() {
        this.loadDropdown();
    }

    componentWillReceiveProps(nextProps){

        if (nextProps.value !== this.props.value && nextProps.value !== undefined &&  nextProps.value !== null ){

            // Controllo che il valore sia presente nell'elenco.
            // Se non c'è lo aggiungo
            let found = this.state.itemList.find((item) => {
                return item.value === nextProps.value
            })
            if (found === undefined && nextProps.value !== this.lastNewValue){

                this.onLoading(true);
                client.saveTestiPerTipo(
                    this.state.tipo, nextProps.value
                ).then((response) => {
                    if (response.ok){
                        response.json().then((data) => {
                            data = convertNullToEmptyString(data);
                            //let fields = this.state.fields;
                            //fields.forma = data.valore;
                            this.onLoading(false);
                            this.setState({
                                inError: false,
                                fieldErrors: {},
                                fieldErrorsText: [],
                                itemList: arrayToComboAdd(this.state.itemList, data, 'valore', 'valore', 'valore'),
                            });
                            // this.loadDropdown();
                            // this.props.onChange(undefined, {name: this.props.name, value: data.valore})
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.props.history.push("/login")
                    }
                    else{
                        this.onLoading(false);
                        this.setState({
                            inError: true,
                            fieldErrors: {'forma': 'errore salvataggio testo'},
                            fieldErrorsText: ["errore caricamento testo"],
                            errorTitle: "Errore imprevisto",
                        });
                    }
                }).catch((error) => {
                    this.onLoading(false);
                    this.setState({
                        fieldErrors: {},
                        fieldErrorsText: [error.message],
                        errorTitle: "Errore di rete imprevisto",
                        inError: true
                    });
                });

            }

        }

    }

    render() {
        return (
            <Form.Dropdown
                label={this.props.label}
                name={this.props.name} fluid selection search allowAdditions
                selectOnBlur={false}
                placeholder={this.props.placeholder}
                additionLabel={this.props.additionLabel}
                loading={this.state.dropdownLoading}
                options={this.state.itemList}
                value={''+this.props.value}
                error={this.props.error}
                required={this.props.required}
                onChange={this.onChange}
                onSearchChange={this.onSearchChange}
                onAddItem={this.onItemAddition}
            />
        )
    }
}

TestiDropdown.PropTypes = {
    tipo: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    maxlength: PropTypes.number.isRequired,
    required: PropTypes.number.isRequired,
    additionLabel: PropTypes.string.isRequired,
    value: PropTypes.string,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onLoading: PropTypes.func.isRequired,
};

TestiDropdown.defaultProps = {
    tipo: 'MFORM',
    maxlength: 255,
    required: false,
    placeholder: ''
};

TestiDropdown.contextTypes = {
    router: PropTypes.object
}

export default TestiDropdown;



/** WEBPACK FOOTER **
 ** ./src/components/TestiDropdown.jsx
 **/